const BYTES_PER_KB = 1024;
const BYTES_PER_MB = BYTES_PER_KB * BYTES_PER_KB;
const formatFileSize = (bytes) => {
    if (bytes < BYTES_PER_KB) {
        return `${bytes} B`;
    }
    if (bytes < BYTES_PER_MB) {
        return `${(bytes / BYTES_PER_KB).toFixed(1)} KB`;
    }
    return `${(bytes / BYTES_PER_MB).toFixed(1)} MB`;
};
export { formatFileSize };
